<template>
	<div class="msg-box">
		<div class="page-title" v-if="pageTotal_ > 0">
			您共有<span>{{pageTotal_}}</span>条消息
		</div>
		<ul class="sys-msg-list">
			<li class="clearfix" v-for="(item, index) in curData_" :key="index">
				<div class="sys-msg-left">
					<img class="poster-image" :src="item.headImage | imgUrl" />
				</div>
				<div class="sys-msg-right">
					<p class="sys-msg-title">
						<span class="fr">{{item.createTime | time}}</span>
						{{item.username}}
					</p>
					<p class="sys-msg-desc">
						<router-link class="btn-primary btn-xs fr" :to="{
							path: '/circles/mine/privateLetter/' + item.memeberId
						}">查看</router-link>{{item.content}}
					</p>
					<!-- <p class="sys-msg-desc">
						<router-link class="btn-primary btn-xs fr" :to="{path: '/circles/mine/systemMessage'}">查看</router-link>{{item.content}}
					</p> -->
					<!-- <div class="replay-box tr">
						<input class="replay__input" />
						<span>回复</span>
					</div> -->
				</div>
			</li>
		</ul>
		<ss-no-data v-if="!finish_ && busy_" text="数据加载中" />
		<ss-no-data v-else-if="finish_ && busy_ && curData_.length === 0" mode="image" text="暂无相关的消息" />
		<div class="right-navigation-box">
			<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
		</div>
	</div>
</template>

<script>
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ]
	}
</script>

<style lang="scss">
	@import './css/message.scss';
</style>
